import React from "react";
import "./InvestRegis.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";


class InvestRegis extends React.Component {
    render() {
        return (
<div>
    <Nav/>
    <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Project">01 Investment Environment</a></p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/ProLoc">Transportation and Logistics</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/InvestRegis"> 02 Investment Registration</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab">03 Industries & Parks</p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoBusiness">Eco-Business Park</a></p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoInov">Eco-Innovation</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Overall">Overall Introduction</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab">04 Real Estate Development</p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/DevPlan">Development Plan</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/DevPlan">Development Milestone</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/DevPlan">05 Partners & Potential Investors</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
            </div>
          </div>
        <div className="col-8">
        <div class="jumbotron">
          <p style={{margin: 0, fontWeight: 'bold', fontSize: '30px'}}>Investment Registration</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}>How to set up office/company in the Good Morning Bamboo Eco-City?</p>
        <p className="text-justify">The Good Morning Bamboo Agro-Forestry and Investment Services will work closely with the local government and the District/Municipal/Metropolitan Administrations to help companies with the registration processes and procedures in the Good Morning Bamboo Eco-City. Please contact our staff who can assist and guide you on how to get started.


</p>
   
       </div>
      
     </div>
   </div>
</div>
        )
    }
}
export default withRouter(InvestRegis);